import { AuthLayout } from "@/layouts/AuthLayout";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import { RootLayout } from "@/layouts/RootLayout";
import { createBrowserRouter } from "react-router-dom";
import { authRoutes } from "./authRoutes";
import { legacyRoutes } from "./legacyRoutes";
import { protectedRoutes } from "./protectedRoutes";
import { publicRoutes } from "./publicRoutes";
import NotFound from "@/pages/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      /**
       *  Public routes (no auth required)
       */
      ...publicRoutes,

      /**
       * Auth routes (with redirects for authenticated users)
       */
      {
        path: "/auth",
        element: <AuthLayout />,
        children: authRoutes,
      },

      /**
       * Protected routes (require auth + org setup)
       */
      {
        path: "/",
        element: <DashboardLayout />,
        children: [...protectedRoutes, ...legacyRoutes],
      },

      /**
       * Catch-all route for 404 Not Found
       */
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);
